// Centralized content for Pixel-Hatch

export const CONTACT = {
  email: "Info@pixel-hatch.com",
  phone: "+91 8448289602",
  address: "Sector 62, Noida, Uttar Pradesh 201309, India",
  region: "Noida · Delhi NCR · India",
};

export const IMAGES = {
  heroSkyline:
    "https://images.unsplash.com/photo-1746299812635-90b58f161937?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwzfHxkZWxoaSUyMG5vaWRhJTIwc2t5bGluZSUyMGNvcnBvcmF0ZSUyMGdsYXNzJTIwYXJjaGl0ZWN0dXJlJTIwYnVzaW5lc3MlMjBkaXN0cmljdHxlbnwwfHx8fDE3ODcwNjQ2MzZ8MA&ixlib=rb-4.1.0&q=85",
  officeMeeting:
    "https://images.unsplash.com/photo-1577962917302-cd874c4e31d2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHxffG1vZGVybiUyMGluZGlhJTIwb2ZmaWNlJTIwdGVjaG5vbG9neSUyMHRlYW0lMjBtZWV0aW5nJTIwY29ycG9yYXRlJTIwbmlkYSUyMGJhbmdhbG9yZXxlbnwwfHx8fDE3ODcwNjQ2MzZ8MA&ixlib=rb-4.1.0&q=85",
  collaboration:
    "https://images.pexels.com/photos/35730225/pexels-photo-35730225.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  leadership:
    "https://images.unsplash.com/photo-1622675363311-3e1904dc1885?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwzfHx0ZWNoJTIwbGVhZGVyJTIwc3RyYXRlZ2ljJTIwbWVldGluZyUyMHNvZnR3YXJlJTIwZGV2ZWxvcGVycyUyMGNvbGxhYm9yYXRpb24lMjBvZmZpY2V8ZW58MHx8fHwxNzg3MDY0NjQ1fDA&ixlib=rb-4.1.0&q=85",
  boardroom:
    "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwyfHx0ZWNoJTIwbGVhZGVyJTIwc3RyYXRlZ2ljJTIwbWVldGluZyUyMHNvZnR3YXJlJTIwZGV2ZWxvcGVycyUyMGNvbGxhYm9yYXRpb24lMjBvZmZpY2V8ZW58MHx8fHwxNzg3MDY0NjQ1fDA&ixlib=rb-4.1.0&q=85",
  team1:
    "https://images.unsplash.com/photo-1556761175-b413da4baf72?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBzb2Z0d2FyZSUyMGVuZ2luZWVyaW5nJTIwdGVhbSUyMG9mZmljZSUyMGNvbGxhYm9yYXRpb258ZW58MHx8fHwxNzg3MDY0ODYzfDA&ixlib=rb-4.1.0&q=85",
  team2:
    "https://images.pexels.com/photos/6804068/pexels-photo-6804068.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  noidaSunrise:
    "https://images.pexels.com/photos/15059576/pexels-photo-15059576.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  noidaNight:
    "https://images.pexels.com/photos/28556110/pexels-photo-28556110.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  indiaRoad:
    "https://images.unsplash.com/photo-1786202162076-204d42f008f2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwxfHxJbmRpYSUyMGJ1c2luZXNzJTIwdGVjaG5vbG9neSUyMGNpdHklMjBhYnN0cmFjdCUyMG5ldHdvcmt8ZW58MHx8fHwxNzg3MDY0ODYzfDA&ixlib=rb-4.1.0&q=85",
  cityDusk:
    "https://images.pexels.com/photos/15582273/pexels-photo-15582273.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const NAV = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "HATCH Framework™", path: "/framework" },
  { label: "Services", path: "/services" },
  { label: "Why India", path: "/why-india" },
  { label: "Why Noida", path: "/why-noida" },
  { label: "Industries", path: "/industries" },
  { label: "Resources", path: "/resources" },
  { label: "Contact", path: "/contact" },
];

export const FRAMEWORK = [
  {
    letter: "H",
    title: "Hear & Understand",
    tagline: "We start by listening.",
    need: "Unclear India strategy, regulatory anxiety, and confusion about real costs and timelines.",
    support: "Deep-dive expansion discovery covering goals, culture, hiring plans, budget, and entity advisory with transparent financial modeling.",
    outcome: "A clear, risk-mitigated India roadmap tailored to your growth goals.",
  },
  {
    letter: "A",
    title: "Activate",
    tagline: "We bring your plan to life.",
    need: "Entity setup delays, legal red tape, and complex tax and compliance hurdles.",
    support: "The right market-entry model — entity setup, EOR, or BOT — plus registrations, banking, and operational planning.",
    outcome: "A compliant, operational India presence established in record time.",
  },
  {
    letter: "T",
    title: "Team Up",
    tagline: "We build your team.",
    need: "Attracting strong Indian talent without a local brand or network.",
    support: "Recruitment, executive hiring, employer branding, employee engagement, and workforce support.",
    outcome: "A high-performing, fully aligned team from day one.",
  },
  {
    letter: "C",
    title: "Care & Comply",
    tagline: "We run the day-to-day.",
    need: "Payroll friction, HR admin burden, and local labour-law compliance risk.",
    support: "End-to-end HR, payroll, finance, accounting, taxation, compliance, procurement, IT, and governance.",
    outcome: "Seamless daily operations with total peace of mind for global leadership.",
  },
  {
    letter: "H",
    title: "Help You Scale",
    tagline: "We grow with you.",
    need: "Scaling bottlenecks, HQ–India misalignment, and productivity plateaus.",
    support: "Leadership support, operational improvement, GCC transformation, and scalable workspace in Noida.",
    outcome: "A self-sustaining, high-ROI capability center that drives core innovation.",
  },
];

export const SERVICE_GROUPS = [
  {
    id: "strategy",
    title: "Strategy & Market Entry",
    icon: "Compass",
    services: [
      { name: "India Market Entry", desc: "Enter India with a clear, structured plan built around your goals and budget." },
      { name: "GCC Strategy", desc: "Design a capability center that maps to your product and engineering roadmap." },
      { name: "Entity Setup", desc: "Incorporate the right legal structure with banking, registrations, and governance handled." },
      { name: "Employer of Record (EOR)", desc: "Hire in India in weeks — no entity required — while we handle employment locally." },
      { name: "Build-Operate-Transfer (BOT)", desc: "Let us build and run your operation, then transition ownership to you when ready." },
    ],
  },
  {
    id: "people",
    title: "People & Talent",
    icon: "Users",
    services: [
      { name: "Recruitment", desc: "Build the right India team across technology, operations, finance, and leadership roles." },
      { name: "Executive Hiring", desc: "Secure senior leaders who can run your India operation with autonomy." },
      { name: "HR Operations", desc: "Keep your team supported with reliable HR and full employee-lifecycle management." },
      { name: "Payroll", desc: "Accurate, on-time payroll with statutory contributions handled correctly." },
      { name: "Employer Branding", desc: "Stand out to top candidates even without an established India brand." },
      { name: "Employee Engagement", desc: "Retain talent with culture, engagement, and performance programs." },
    ],
  },
  {
    id: "operations",
    title: "Business Operations",
    icon: "Building2",
    services: [
      { name: "Finance", desc: "Local finance operations aligned with your HQ reporting and controls." },
      { name: "Accounting", desc: "Books kept clean and compliant with Indian accounting standards." },
      { name: "Taxation", desc: "Navigate direct and indirect taxes with appropriate professional support." },
      { name: "Compliance", desc: "Stay ahead of labour, corporate, and regulatory obligations." },
      { name: "Procurement", desc: "Source vendors, assets, and services at the right price and quality." },
      { name: "Managed Operations", desc: "Hand us selected or complete functions and focus on your product." },
    ],
  },
  {
    id: "technology",
    title: "Technology & Workplace",
    icon: "Cpu",
    services: [
      { name: "IT Infrastructure", desc: "Set up secure, scalable IT and networks for your India team." },
      { name: "Hardware Procurement", desc: "Devices and equipment procured, configured, and delivered ready to use." },
      { name: "Office Leasing", desc: "Find and secure the right space in Noida and across NCR." },
      { name: "Workspace Setup", desc: "Fit-out, seating, and facilities that reflect your brand and culture." },
      { name: "Technology Support", desc: "Ongoing IT support so your team stays productive and secure." },
    ],
  },
];

export const ENGAGEMENT_MODELS = [
  { id: "gcc", name: "GCC", tag: "Dedicated Center", desc: "Build a dedicated India capability center aligned with your business and product roadmap." },
  { id: "eor", name: "EOR", tag: "Fastest Start", desc: "Start hiring in India quickly while Pixel-Hatch supports employment and local operations." },
  { id: "bot", name: "BOT", tag: "Build → Transfer", desc: "Build your India operation with our support and transition toward independent ownership when ready." },
  { id: "managed", name: "Managed Operations", tag: "Fully Handled", desc: "Let Pixel-Hatch manage selected or complete operational functions on your behalf." },
  { id: "custom", name: "Customized Model", tag: "Tailored", desc: "A solution based on your team size, timeline, budget, and business requirements." },
];

export const WHY_POINTS = [
  { title: "Faster Setup", desc: "Accelerate your India market entry with a structured, proven process.", icon: "Rocket" },
  { title: "Lower Complexity", desc: "Reduce the burden of coordinating multiple vendors and functions.", icon: "Layers" },
  { title: "Strong Noida Presence", desc: "Local knowledge of the Noida/NCR ecosystem, talent, and infrastructure.", icon: "MapPin" },
  { title: "Transparent Pricing", desc: "Clear commercial structures without unnecessary complexity.", icon: "Receipt" },
  { title: "Compliance Expertise", desc: "Navigate HR, tax, employment, and legal requirements with professional support.", icon: "ShieldCheck" },
  { title: "Flexible & Scalable", desc: "Start small and scale as your business grows.", icon: "TrendingUp" },
  { title: "Long-Term Partnership", desc: "We support you far beyond the initial setup.", icon: "HeartHandshake" },
];

export const WHY_INDIA = [
  { title: "Large Skilled Talent Pool", desc: "Access one of the world's deepest pools of engineering and technology talent." },
  { title: "Technology Ecosystem", desc: "A mature ecosystem of product, services, and startup companies." },
  { title: "Competitive Operating Costs", desc: "Meaningful cost efficiency without compromising on capability." },
  { title: "English-Speaking Workforce", desc: "Smooth collaboration with global teams and stakeholders." },
  { title: "Strong Engineering Capability", desc: "Proven depth across software, data, AI, and platform engineering." },
  { title: "Mature Digital Infrastructure", desc: "Reliable connectivity, cloud, and digital public infrastructure." },
  { title: "Time-Zone Advantage", desc: "Overlap with global teams and extend your productive working day." },
  { title: "Growing GCC Ecosystem", desc: "A thriving base of global capability centers to learn and hire from." },
  { title: "Specialized Talent Access", desc: "Reach niche technology skills that are scarce in other markets." },
];

export const WHY_NOIDA = [
  { title: "Strong Technology Ecosystem", desc: "A growing hub of software, SaaS, and technology companies." },
  { title: "Access to Skilled Talent", desc: "Deep engineering and operations talent across the region." },
  { title: "Proximity to Delhi", desc: "Close to the national capital and its institutions and networks." },
  { title: "Excellent Connectivity", desc: "Metro, expressways, and international airport access." },
  { title: "Access to NCR Talent", desc: "Draw from the wider Delhi-NCR talent catchment." },
  { title: "Modern Commercial Infrastructure", desc: "Grade-A offices, business parks, and reliable utilities." },
  { title: "Competitive Operating Environment", desc: "Attractive costs relative to other major metros." },
  { title: "Startup & Tech Ecosystem", desc: "A supportive environment for new and growing operations." },
];

export const INDUSTRIES = [
  { name: "AI", icon: "BrainCircuit", desc: "Build applied-AI and ML teams close to specialized research and engineering talent." },
  { name: "SaaS", icon: "CloudCog", desc: "Scale product, engineering, and customer teams for your subscription business." },
  { name: "Software & Technology", icon: "Code2", desc: "Stand up full engineering pods that ship alongside your HQ roadmap." },
  { name: "FinTech", icon: "Landmark", desc: "Grow compliant fintech teams with strong data, security, and ops discipline." },
  { name: "HealthTech", icon: "HeartPulse", desc: "Build teams for health platforms with an eye on privacy and reliability." },
  { name: "EdTech", icon: "GraduationCap", desc: "Scale content, engineering, and support for global learning products." },
  { name: "E-commerce", icon: "ShoppingCart", desc: "Power catalog, platform, and operations teams for high-growth commerce." },
  { name: "Manufacturing", icon: "Factory", desc: "Establish digital, engineering, and shared-services functions in India." },
  { name: "Professional Services", icon: "Briefcase", desc: "Build delivery and back-office capability that scales with clients." },
  { name: "Cybersecurity", icon: "Lock", desc: "Grow security engineering and SOC teams with the right talent and controls." },
  { name: "Gaming", icon: "Gamepad2", desc: "Build art, engineering, and live-ops teams for global gaming studios." },
  { name: "Business Services", icon: "Network", desc: "Stand up scalable operations and support functions across the board." },
];

export const TRUST = [
  { title: "Experienced Team", desc: "A team with real depth across GCC setup, operations, and technology.", icon: "Users" },
  { title: "Transparent Approach", desc: "Clear scope, clear pricing, and honest advice at every step.", icon: "Eye" },
  { title: "Structured Methodology", desc: "The HATCH Framework™ turns complexity into a clear path.", icon: "Route" },
  { title: "Local Expertise", desc: "On-the-ground knowledge of Noida, NCR, and Indian regulation.", icon: "MapPin" },
  { title: "Customer-First Model", desc: "We shape the engagement around your goals, not a fixed template.", icon: "Heart" },
  { title: "End-to-End Support", desc: "One partner across strategy, people, operations, and technology.", icon: "Infinity" },
];

export const CASE_STUDIES = [
  {
    slug: "saas-scaleup-first-ten-engineers",
    sector: "SaaS",
    tag: "EOR → Team Build",
    title: "A SaaS scale-up hiring its first 10 engineers in India",
    teaser: "We handle EOR employment, recruitment, payroll, and IT so the team is productive fast — no entity required on day one.",
    image: IMAGES.team1,
    model: "Employer of Record (EOR)",
    situation: [
      "A fast-growing SaaS company has product-market fit and a roadmap that's outpacing its home-market hiring. Leadership wants to add ten strong engineers quickly, but setting up an Indian entity feels like a months-long detour they can't afford right now.",
      "Their concerns are familiar: How do we hire without a legal entity? Who runs payroll and compliance? How do we make sure the team is set up and productive from week one, not week twelve?",
    ],
    approach: [
      { letter: "H", title: "Hear & Understand", text: "We start by mapping the ten roles, the seniority mix, target compensation, and the timeline — and confirm EOR is the fastest, lowest-risk way to start." },
      { letter: "A", title: "Activate", text: "We stand up EOR employment so people can be hired legally and compliantly in weeks, with no entity required on day one." },
      { letter: "T", title: "Team Up", text: "We run structured recruitment across the engineering roles, manage interview loops, and design competitive local offers." },
      { letter: "C", title: "Care & Comply", text: "We handle payroll, statutory contributions, HR, and IT provisioning so laptops, access, and onboarding are ready before day one." },
    ],
    results: [
      "First hires productive in weeks, not months",
      "Zero entity setup required to begin",
      "Payroll, HR, and compliance fully managed",
      "A clear path to a full entity when the team grows",
    ],
  },
  {
    slug: "ai-company-thirty-person-rnd-center",
    sector: "AI",
    tag: "Full GCC Build",
    title: "An AI company building a 30-person R&D center",
    teaser: "We design the GCC, incorporate the entity, build the team, and run HR, finance, and compliance end-to-end.",
    image: IMAGES.collaboration,
    model: "Full GCC Build & Manage",
    situation: [
      "An AI company is ready to commit to India for the long term. They want a dedicated research and engineering center of around thirty people — their own entity, their own culture, deeply integrated with headquarters.",
      "The challenge is scale and coordination: entity incorporation, leadership hiring, a growing team, workspace, and a web of finance, tax, and compliance obligations — all of which need to come together on a tight timeline.",
    ],
    approach: [
      { letter: "H", title: "Hear & Understand", text: "We build the center's blueprint — how it maps to the product roadmap, the leadership structure, and a realistic 12-month ramp." },
      { letter: "A", title: "Activate", text: "We incorporate the entity, complete registrations and banking, and set up governance so the center is operational and compliant." },
      { letter: "T", title: "Team Up", text: "We hire leadership first, then build the core R&D team with employer branding and structured technical hiring." },
      { letter: "C", title: "Care & Comply", text: "We run HR, payroll, finance, accounting, taxation, compliance, and IT — and set up workspace in Noida built to scale." },
      { letter: "H", title: "Help You Scale", text: "We support leadership, HQ integration, and operational improvement as the center grows beyond its first thirty people." },
    ],
    results: [
      "A dedicated, fully owned India R&D center",
      "Entity, workspace, and operations stood up in parallel",
      "Leadership and core team hired and integrated with HQ",
      "A center designed to scale well beyond the first 30",
    ],
  },
  {
    slug: "software-company-testing-india-with-bot",
    sector: "Software & Technology",
    tag: "Build-Operate-Transfer",
    title: "A software company testing India before committing",
    teaser: "We start with a BOT model, prove the operation, and transition ownership to you when you're ready.",
    image: IMAGES.leadership,
    model: "Build-Operate-Transfer (BOT)",
    situation: [
      "A software company sees the opportunity in India but isn't ready to fully commit to owning an entity and operation from day one. They want to prove the model first — with a clear, low-risk path to full ownership later.",
      "They need a partner who can build and run the operation on their behalf, demonstrate that it works, and then hand over the keys cleanly when the time is right.",
    ],
    approach: [
      { letter: "H", title: "Hear & Understand", text: "We define what 'proven' looks like — the team, the metrics, and the trigger points for transferring ownership." },
      { letter: "A", title: "Activate", text: "We build and operate the India operation under a BOT structure, so the company can start without carrying full ownership risk." },
      { letter: "T", title: "Team Up", text: "We recruit and build the team, embedding the company's ways of working from the start." },
      { letter: "C", title: "Care & Comply", text: "We run day-to-day operations, HR, payroll, finance, and compliance while the operation matures." },
      { letter: "H", title: "Help You Scale", text: "When the milestones are met, we transition ownership smoothly toward an independently run operation." },
    ],
    results: [
      "A de-risked way to prove the India thesis",
      "A working operation before full commitment",
      "The company's culture embedded from day one",
      "A clean, planned transition to full ownership",
    ],
  },
];

export const FAQS = [
  { q: "Do we need to set up a legal entity to hire in India?", a: "Not necessarily. With an Employer of Record (EOR) model you can hire in India without your own entity. We help you decide whether EOR, a full entity, or a BOT approach fits your goals and timeline." },
  { q: "How long does it take to start operating in India?", a: "With EOR, hiring can begin in a matter of weeks. A full entity setup typically takes longer, and we plan the sequence so you can start building while structures are finalized." },
  { q: "What is the difference between GCC, EOR, and BOT?", a: "A GCC is your own dedicated capability center. EOR lets you employ people through a local partner without an entity. BOT means we build and operate first, then transfer ownership to you. Many companies blend these over time." },
  { q: "How is Pixel-Hatch different from a recruitment or outsourcing firm?", a: "We are an India expansion partner, not a staffing vendor. We support the full journey — strategy, entity, hiring, HR, payroll, finance, compliance, IT, and scaling — as a single accountable partner." },
  { q: "Why Noida instead of another Indian city?", a: "Noida offers strong technology talent, modern infrastructure, excellent NCR connectivity, and competitive costs. It's our local strength — though we always recommend the right location for your specific needs." },
  { q: "How is pricing structured?", a: "We use clear, transparent commercial structures tied to the scope you choose. You'll always understand what you're paying for before you commit." },
];

export const RESOURCE_CATEGORIES = [
  "India Expansion", "GCC Guides", "EOR vs GCC vs BOT", "Hiring", "Compliance", "Cost", "Noida",
];

export const BLOG_POSTS = [
  {
    slug: "eor-vs-gcc-vs-bot-india",
    title: "EOR vs GCC vs BOT: Choosing the Right India Entry Model",
    category: "EOR vs GCC vs BOT",
    excerpt: "Three common ways to build in India — and a simple way to decide which fits your stage, timeline, and long-term ambition.",
    readTime: "7 min read",
    date: "Jun 2026",
    image: IMAGES.boardroom,
    content: [
      { type: "p", text: "If you're expanding into India, you'll quickly meet three acronyms: EOR, GCC, and BOT. They aren't competing products — they're different points on the same journey. The right choice depends on how fast you need to move, how much control you want, and how large you plan to grow." },
      { type: "h", text: "Employer of Record (EOR)" },
      { type: "p", text: "EOR lets you hire people in India without setting up your own legal entity. A local partner becomes the legal employer, handling payroll, statutory contributions, and compliance, while your team works entirely on your product. It's the fastest way to start — often within weeks — and the easiest to unwind if your plans change." },
      { type: "p", text: "EOR is ideal when you're hiring your first few people, testing the market, or bridging the gap while a full entity is being established." },
      { type: "h", text: "Global Capability Center (GCC)" },
      { type: "p", text: "A GCC is your own dedicated center in India — your entity, your team, your culture. It offers maximum control and is the model most global companies grow into. The trade-off is that setup takes longer and involves entity incorporation, banking, compliance, and operational infrastructure." },
      { type: "p", text: "A GCC makes sense once you're committed to a meaningful, long-term presence and want the team to feel fully part of your company." },
      { type: "h", text: "Build-Operate-Transfer (BOT)" },
      { type: "p", text: "BOT is the bridge between the two. A partner builds and operates the India operation on your behalf, then transfers ownership to you once it's proven and stable. You de-risk the build while keeping a clear path to a fully owned GCC." },
      { type: "h", text: "A simple way to decide" },
      { type: "p", text: "Start with EOR if speed matters and the team is small. Choose BOT if you want a GCC eventually but want to de-risk the build. Go straight to a GCC if you're already committed to scale and want full control from day one. Many companies blend all three over time — and that's exactly the kind of phased plan we help design." },
    ],
  },
  {
    slug: "cost-of-building-a-team-in-india",
    title: "What It Really Costs to Build a Team in India",
    category: "Cost",
    excerpt: "Beyond salaries: the real components of India operating cost, and where global companies tend to underestimate.",
    readTime: "6 min read",
    date: "Jun 2026",
    image: IMAGES.team1,
    content: [
      { type: "p", text: "One of the first questions every founder asks is simple: what will this actually cost? The honest answer is that salaries are only part of the picture. Understanding the full cost base up front prevents surprises later." },
      { type: "h", text: "The main cost components" },
      { type: "p", text: "Expect to plan for compensation and statutory contributions, workspace and facilities, IT and hardware, HR and payroll operations, compliance and accounting, and recruitment. Depending on your model, some of these are bundled into a single partner fee; in others you manage them separately." },
      { type: "h", text: "Where companies underestimate" },
      { type: "p", text: "The most common gaps are compliance overhead, the cost of coordinating multiple vendors, and the hidden time cost on your leadership team. Managing ten vendors across HR, payroll, IT, and facilities is expensive in ways that never show up on an invoice." },
      { type: "h", text: "How to keep costs predictable" },
      { type: "p", text: "Consolidate functions under one accountable partner, insist on transparent commercial structures, and start with a model that matches your stage. This is why we emphasize clear pricing — you should always know what you're paying for before you commit." },
    ],
  },
  {
    slug: "hiring-top-tech-talent-in-india",
    title: "How to Hire Strong Technology Talent in India",
    category: "Hiring",
    excerpt: "Attracting great engineers without an established local brand — a practical playbook for global companies.",
    readTime: "6 min read",
    date: "May 2026",
    image: IMAGES.collaboration,
    content: [
      { type: "p", text: "India has one of the deepest technology talent pools in the world. The challenge for a new entrant isn't availability — it's standing out as an unknown brand competing with well-known local and global employers." },
      { type: "h", text: "Build local employer equity early" },
      { type: "p", text: "Great candidates want to know who you are, what you're building, and why it matters. A clear local employer brand — even a simple, honest one — dramatically improves response rates and offer acceptance." },
      { type: "h", text: "Design a structured hiring loop" },
      { type: "p", text: "Consistent, well-run interview processes protect quality and candidate experience. Define role scorecards, calibrate interviewers, and move quickly — strong candidates have options and slow processes lose them." },
      { type: "h", text: "Get compensation right" },
      { type: "p", text: "Benchmark against the local market for the specific skills you need, not a generic average. Competitive, well-structured offers reduce attrition and signal that you take the India team seriously." },
    ],
  },
  {
    slug: "india-compliance-basics-for-global-companies",
    title: "India Compliance Basics for Global Companies",
    category: "Compliance",
    excerpt: "A plain-English overview of the compliance landscape so you know what to plan for — without the jargon.",
    readTime: "5 min read",
    date: "May 2026",
    image: IMAGES.officeMeeting,
    content: [
      { type: "p", text: "Compliance is the area that worries global leaders most — and the area where a good partner adds the most peace of mind. You don't need to become an expert; you do need to know what exists and ensure it's handled." },
      { type: "h", text: "The broad categories" },
      { type: "p", text: "Plan for corporate compliance (if you have an entity), employment and labour law, payroll-related statutory contributions, and tax obligations across direct and indirect taxes. Each has its own filings and timelines." },
      { type: "h", text: "The cost of getting it wrong" },
      { type: "p", text: "Missed filings and misclassifications create penalties and, worse, distraction. The goal isn't just to be compliant once — it's to stay compliant month after month without it consuming your leadership's attention." },
      { type: "h", text: "How we help" },
      { type: "p", text: "We coordinate HR, payroll, finance, and legal so obligations are met on time, with appropriate professional support. You get clear visibility and a single point of accountability." },
    ],
  },
  {
    slug: "why-noida-for-your-india-operations",
    title: "Why Noida Is a Smart Base for Your India Operations",
    category: "Noida",
    excerpt: "Talent, infrastructure, connectivity, and cost — what makes Noida a strong choice for a technology operation.",
    readTime: "5 min read",
    date: "Apr 2026",
    image: IMAGES.noidaSunrise,
    content: [
      { type: "p", text: "Location matters more than many first-time entrants expect. It shapes your talent access, your costs, and how easily your team can grow. Noida, in the Delhi-NCR region, is a strong base for technology operations — and it's where our local strength lies." },
      { type: "h", text: "Talent and ecosystem" },
      { type: "p", text: "Noida sits within one of India's largest talent catchments, with strong engineering and operations talent and a growing base of technology and SaaS companies." },
      { type: "h", text: "Infrastructure and connectivity" },
      { type: "p", text: "Grade-A office space, reliable utilities, metro connectivity, expressways, and airport access make it practical to build and scale a modern operation." },
      { type: "h", text: "Cost and environment" },
      { type: "p", text: "Noida offers competitive operating costs relative to other major metros, with a supportive environment for new and growing operations. We always recommend the right location for your needs — but for many technology companies, Noida is a compelling starting point." },
    ],
  },
  {
    slug: "building-your-first-india-gcc",
    title: "A Founder's Guide to Building Your First India GCC",
    category: "GCC Guides",
    excerpt: "From first hire to a self-sustaining capability center — the milestones that matter and the order to tackle them.",
    readTime: "8 min read",
    date: "Apr 2026",
    image: IMAGES.leadership,
    content: [
      { type: "p", text: "A Global Capability Center is more than an offshore team — it's a strategic extension of your company. Building one well is a sequence of decisions, and getting the order right saves time and money." },
      { type: "h", text: "Start with strategy, not hiring" },
      { type: "p", text: "Before you post a single role, get clear on what the center is for, how it maps to your product roadmap, and how large you expect it to grow. This shapes every downstream choice, from entity structure to leadership hiring." },
      { type: "h", text: "Sequence the build" },
      { type: "p", text: "Typically: define strategy, choose the entry model, establish the entity or EOR, hire leadership, build the core team, and stand up HR, finance, compliance, and IT in parallel. Then focus on culture and integration with HQ." },
      { type: "h", text: "Plan for scale from day one" },
      { type: "p", text: "The best GCCs are designed to grow. Build workspace, processes, and leadership that can absorb the next 50 people, not just the first 10. That's the difference between an offshore cost center and a genuine capability center." },
      { type: "h", text: "The HATCH Framework™" },
      { type: "p", text: "This sequence is exactly what our HATCH Framework™ is built around — Hear, Activate, Team Up, Care & Comply, and Help You Scale. It turns a complex, multi-year journey into a clear, manageable path." },
    ],
  },
];
